import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=0c43229c&scoped=true&"
import script from "./warehouse.vue?vue&type=script&lang=ts&"
export * from "./warehouse.vue?vue&type=script&lang=ts&"
import style0 from "./warehouse.vue?vue&type=style&index=0&id=0c43229c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43229c",
  null
  
)

export default component.exports